import React from "react";

export function FullBackupNote(): JSX.Element {
  return (
    <div style={{ marginBottom: "24px", padding: "12px", backgroundColor: "#f5f5f5", borderRadius: "4px" }}>
      <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>
        The full backup will replace the saved configuration on the selected devices. Keep them powered on while it is
        applied.
      </p>
    </div>
  );
}
